var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { inject, injectable } from '@servicetitan/react-ioc';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import queryString from 'query-string';
import { CONTENTFUL_API_TOKEN } from '@servicetitan/contentful-proxy';
const carouselBackgroundLightPath = 'https://static.servicetitan.com/acm/auth/sign-in-carousel-background.png';
export var MarketingCarouselColorTheme;
(function (MarketingCarouselColorTheme) {
    MarketingCarouselColorTheme["Light"] = "Light";
    MarketingCarouselColorTheme["Dark"] = "Dark";
})(MarketingCarouselColorTheme || (MarketingCarouselColorTheme = {}));
let MarketingCarouselStore = class MarketingCarouselStore {
    constructor(contentfulApi) {
        Object.defineProperty(this, "contentfulApi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: contentfulApi
        });
        Object.defineProperty(this, "isInitializing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "photoGalleryData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "utmSource", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fallbackData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initialize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ({ codeId, utmSource, fallbackData, isPreview = false, }) => __awaiter(this, void 0, void 0, function* () {
                this.isInitializing = true;
                this.utmSource = utmSource;
                this.fallbackData = fallbackData;
                try {
                    const data = yield this.contentfulApi.getContentfulData({
                        entryType: 'oxPhotoGallery',
                        codeId,
                        isPreview: isPreview !== null && isPreview !== void 0 ? isPreview : false,
                    });
                    if (!(data === null || data === void 0 ? void 0 : data.items.length)) {
                        return;
                    }
                    runInAction(() => {
                        this.photoGalleryData = data;
                    });
                }
                finally {
                    runInAction(() => {
                        this.isInitializing = false;
                    });
                }
            })
        });
        Object.defineProperty(this, "getCtaLink", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (ctaLink, ctaTrackingCode) => {
                if (!ctaTrackingCode) {
                    return ctaLink;
                }
                const qs = queryString.parse(ctaTrackingCode);
                if (this.utmSource) {
                    qs.utm_source = this.utmSource;
                }
                return `${ctaLink}?${queryString.stringify(qs)}`;
            }
        });
        Object.defineProperty(this, "isDateRangeActive", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (start, end) => {
                if (!start && !end) {
                    return true;
                }
                const localCurrentTime = new Date().getTime();
                const inStartRange = !start || localCurrentTime >= new Date(start).getTime();
                const inEndRange = !end || localCurrentTime < new Date(end).getTime();
                return inStartRange && inEndRange;
            }
        });
        makeObservable(this);
    }
    // colorTheme and backgroundImageUrl are not not part of initial release of contentful
    get carouselSettings() {
        var _a;
        return this.photoGalleryData
            ? {
                backgroundImageUrl: carouselBackgroundLightPath,
                colorTheme: MarketingCarouselColorTheme.Light,
            }
            : (_a = this.fallbackData) === null || _a === void 0 ? void 0 : _a.carouselSettings;
    }
    get carouselData() {
        var _a, _b, _c, _d, _e;
        try {
            if (!((_a = this.photoGalleryData) === null || _a === void 0 ? void 0 : _a.items)) {
                return (_b = this.fallbackData) === null || _b === void 0 ? void 0 : _b.carouselData;
            }
            return ((_c = this.photoGalleryData.items
                .filter(({ showDate, hideDate }) => this.isDateRangeActive(showDate, hideDate))
                .map((_a) => {
                var { ctaLink, ctaTrackingCode, media } = _a, fields = __rest(_a, ["ctaLink", "ctaTrackingCode", "media"]);
                return (Object.assign(Object.assign({}, fields), { ctaLink: this.getCtaLink(ctaLink, ctaTrackingCode), imageUrl: media.file.url.replace('//', 'https://') }));
            })) !== null && _c !== void 0 ? _c : (_d = this.fallbackData) === null || _d === void 0 ? void 0 : _d.carouselData);
        }
        catch (_f) {
            return (_e = this.fallbackData) === null || _e === void 0 ? void 0 : _e.carouselData;
        }
    }
};
__decorate([
    observable,
    __metadata("design:type", Object)
], MarketingCarouselStore.prototype, "isInitializing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MarketingCarouselStore.prototype, "photoGalleryData", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], MarketingCarouselStore.prototype, "utmSource", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MarketingCarouselStore.prototype, "fallbackData", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], MarketingCarouselStore.prototype, "initialize", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], MarketingCarouselStore.prototype, "carouselSettings", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], MarketingCarouselStore.prototype, "carouselData", null);
MarketingCarouselStore = __decorate([
    injectable(),
    __param(0, inject(CONTENTFUL_API_TOKEN)),
    __metadata("design:paramtypes", [Object])
], MarketingCarouselStore);
export { MarketingCarouselStore };
//# sourceMappingURL=marketing-carousel.store.js.map